import { useCallback } from 'react';
import { CARDS_BASE_PATH } from '@apps/card/Card.routes';
import { useFeatureFlagsContext } from '@shared/core/featureFlags';
import { withWindow } from '@shared/utils/withWindow';

export const AUTH_REDIRECT_PARAM = 'isComingFromAuth';

const createURL = (win: Window, state: string | null, redirectPath: string) => {
  const url = new URL(win.location.href);
  url.pathname = redirectPath;
  const searchParams = url.searchParams;
  if (state) {
    searchParams.set('state', state);
  }
  searchParams.set(AUTH_REDIRECT_PARAM, 'true');
  return url.href;
};

export const useAuthRedirectURLs = () => {
  const redirectPath = CARDS_BASE_PATH;
  const { formatToUrl } = useFeatureFlagsContext();

  return useCallback(
    (successState: string, failState: string) => {
      return {
        success: formatToUrl(createURL(window, successState, redirectPath)),
        failure: formatToUrl(createURL(window, failState, redirectPath)),
      };
    },
    [formatToUrl, redirectPath],
  );
};

export const useAuthLogoutRedirectURL = () => {
  const redirectPath = CARDS_BASE_PATH;
  const { formatToUrl } = useFeatureFlagsContext();
  return withWindow(global => {
    return formatToUrl(createURL(global, null, redirectPath));
  }, undefined);
};
